import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENV_CONFIG } from '../../environments/environment.config';
import { 
  OnboardingStartRequest, 
  OnboardingStartResponse,
  FirstLoginRequest,
  FirstLoginResponse,
  SendTokenRequest,
  SendVerificationRequest,
  SendVerificationResponse,
  ValidateTokenRequest,
  ValidateTokenResponse,
  CompleteProfileRequest,
  CompleteProfileResponse
} from '../types/onboarding.model';

interface GenericResponse {
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OnboardingHttpService {
  private http = inject(HttpClient);
  private readonly BASE = ENV_CONFIG.api.onboarding;

  startOnboarding(request: OnboardingStartRequest): Observable<OnboardingStartResponse> {
    return this.http.post<OnboardingStartResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.start}`,
      request
    );
  }

  firstLogin(request: FirstLoginRequest): Observable<FirstLoginResponse> {
    return this.http.post<FirstLoginResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.firstLogin}`,
      request
    );
  }

  sendToken(request: SendTokenRequest): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.sendToken}`,
      request
    );
  }

  sendVerificationCode(request: SendVerificationRequest): Observable<SendVerificationResponse> {
    return this.http.post<SendVerificationResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.sendVerification}`,
      request
    );
  }

  validateVerificationToken(request: ValidateTokenRequest): Observable<ValidateTokenResponse> {
    return this.http.post<ValidateTokenResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.validateToken}`,
      request
    );
  }

  completeProfile(request: CompleteProfileRequest): Observable<CompleteProfileResponse> {
    return this.http.put<CompleteProfileResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.profile}`,
      request
    );
  }

  finalizeOnboarding(idUser: string): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(
      `${this.BASE}${ENV_CONFIG.endpoints.onboarding.finalize(idUser)}`,
      {}
    );
  }
}
